// Angular
import { Component, Input, OnChanges } from '@angular/core';

// Afidium
import { ISummarySectorStay } from '../../shared/interfaces/ISummary';
import { IDurationDayNight, IGetBookingsStayResponse, IProperty } from 'libraries/service/resources/booking/interfaces/IGetBookings';
import { DatesService } from 'app_sasha/shared/services/dates/dates.service';
import { SUMMARY_LABELS } from '../../shared/wordings/summary';
import { Yii } from 'libraries/interfaces/Yii';

import { faBed, IconDefinition } from "@fortawesome/free-solid-svg-icons";

@Component({
    selector: 'stay-summary',
    template: `
        <div class="informations-container" [class.details-closed]="!detailsIsShown">
            <fa-icon [icon]="iconBed" class="label-icon" [class.hide-icon]="!showIcon"></fa-icon>
            <div class="informations">
                <div class="dates">
                    <span *ngIf="sector.begin" class="begin-date">{{ labels.from }}
                        <strong>{{ dates.begin }}</strong></span>
                    <span *ngIf="sector.end" class="end-date">{{ labels.to }} <strong>{{ dates.end }}</strong></span>
                    <span class="duration">{{ dates.duration }}</span>
                </div>

                <strong class="name" *ngIf="name && !detailsIsShown">{{ name }}</strong>

                <references [host]="booking.host"
                            [code]="booking.code"
                            [link]="booking.site?.text"
                            *ngIf="booking && !detailsIsShown"></references>


            </div>
        </div>
    `,
    styles: [`
        .informations-container {
            display: flex;
        }

        .dates {
            display: flex;
            flex-direction: column;
        }

        references {
            word-break: break-all;
        }

        references ::ng-deep .references btn.host .btn,
        references ::ng-deep .references .host {
            font-size: .85rem;
        }

        .informations {
            display: flex;
            flex: 1;
            justify-content: space-between;
            flex-wrap: wrap;
            flex-direction: column;
        }

        .details-open {
            flex-direction: column;
        }

        .details-open .references {
            display: flex;
            flex-direction: column;
        }

        .label-icon {
            margin-right: .75rem;
        }

        .duration, .host {
            font-size: 0.90rem;
        }

        .name {
            width: 155px;
            margin: .75rem 0;
        }

        .reference {
            color: #2b78e4;
        }

        .details-closed .name {
            width: unset;
        }

        .details-closed .informations {
            flex-direction: row;
        }

        price-with-conversion {
            text-align: right;
            padding-top: .75rem;
        }

        .hide-icon{
            display: none;
        }
    `]
})
export class StaySummaryComponent implements OnChanges {
    @Input()
    public sector: ISummarySectorStay;

    @Input()
    public booking: IGetBookingsStayResponse;

    @Input()
    public detailsIsShown: boolean = true;

    @Input()
    public showIcon: boolean = true;

    @Input()
    public hotelName: string;

    public dates: {
        begin: string;
        end: string;
        duration: string;
    };

    public labels: { [key: string]: string } = SUMMARY_LABELS;
    public property: IProperty;

    public name: string;

    public iconBed: IconDefinition = faBed;

    constructor(
        private readonly datesService: DatesService
    ) { }

    public ngOnChanges(): void {
        this.dates = {
            begin: this.datesService.formatDate(this.sector.begin, 'momentMedium'),
            end: this.datesService.formatDate(this.sector.end, 'momentMedium'),
            duration: this.getDuration(this.sector.duration),
        };

        if (this.booking && this.sector && this.sector.property && this.sector.property.xId) {
            this.property = (this.booking.property || []).find((property: IProperty) => property.xId === this.sector.property.xId);
            this.name = this.hotelName || this.property ? this.property.name : null;
        } else {
            this.property = undefined;
            this.name = this.hotelName;
        }
    }

    private getDuration(durationDayNight: IDurationDayNight): string {
        const { day, night }: { day?: number, night: number } = durationDayNight;
        let duration: string;

        if (this.sector.xType === 'stay') {
            duration = `(${day} ${(day > 1) ? Yii.t('wui-shared-js', 'jours') : Yii.t('wui-shared-js', 'jour') }`;
            duration += ` ${night} ${(night > 1) ? Yii.t('wui-shared-js', 'nuits') : Yii.t('wui-shared-js', 'nuit')})`;
        }

        return duration;
    }
}
